module.exports = __webpack_public_path__ + "img/tech.104134e7.png";